import $script from 'scriptjs';

export default class PlaidLink {
  handler;
  resolveHandler;
  handlerIsReady = new Promise(resolve => (this.resolveHandler = resolve));

  constructor(config) {
    $script(config.cdn || '//cdn.plaid.com/link/v2/stable/link-initialize.js', () => this.setupHandler(config));
  }

  setupHandler = ({ cdn, ...config }) =>
    (this.handler = Plaid.create({
      ...config,
      onLoad: this.resolveHandler,
      onSuccess: this.onSuccess,
      onExit: this.onExit,
    }));

  onSuccess = (public_token, metadata) => {
    this.resolvePlaid({
      public_token,
      metadata,
    });
  };

  onExit = (err, metadata) => {
    this.rejectPlaid({
      err,
      metadata,
    });
  };

  open = () => {
    const self = this;
    return self.handlerIsReady.then(() => {
      self.handler.open();
      return new Promise((resolve, reject) => {
        self.resolvePlaid = resolve;
        self.rejectPlaid = reject;
      });
    });
  };
}
